module.exports = __webpack_public_path__ + "static/media/passport.2af8f43e.jpg";